import { render, staticRenderFns } from "./orAccountManagement.vue?vue&type=template&id=e5d3dcda&scoped=true"
import script from "./orAccountManagement.vue?vue&type=script&lang=js"
export * from "./orAccountManagement.vue?vue&type=script&lang=js"
import style0 from "./orAccountManagement.vue?vue&type=style&index=0&id=e5d3dcda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d3dcda",
  null
  
)

export default component.exports